import { ICellRendererParams } from 'ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer';
import TableCellRenderer from '@cp/src/components/TableCellRenderer';
import cx from 'classnames';
import { IAgentPerformanceParams } from '../../constants/types';
import styles from './index.module.scss';
import commonCell from './commonCell';
import { DateFormat, getFormattedDateSubtractedByDays, monthNames } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { renderContent } from './utils';
import { GenericObject } from '@cp/src/types/CommonConstans';

export const AgentAvailabilityHistoryColumns = (urlParams: IAgentPerformanceParams) => {
  const todayDate = getFormattedDateSubtractedByDays(7);
  const StartDate = urlParams?.startDate || todayDate;
  const startDateObject = dayjs(StartDate, DateFormat.DD_MM_YYYY);

  const generateColumns = (
    formattedDates: string[],
    dateStrings: string[],
    urlParams: IAgentPerformanceParams
  ) => {
    const columns: GenericObject = [];
    const NO_OF_DAYS = 7;

    Array.from({ length: NO_OF_DAYS }).forEach((_, i) => {
      columns.push({
        headerName: formattedDates[i],
        field: '',
        headerClass: styles.loginTimeHeader,
        width: 115,
        cellRenderer: (params: ICellRendererParams) => {
          const { historyData } = params.data;
          const data = historyData[dateStrings[i]];
          return commonCell(urlParams, data);
        }
      });
    });

    return columns;
  };

  const createDateArray = (): { formattedDates: string[]; dateStrings: string[] } => {
    const formattedDates: string[] = [];
    const dateStrings: string[] = [];
    for (let i = 0; i < 7; i++) {
      const currentDateObject = startDateObject.add(i, 'day').format(DateFormat.ISO_DATE_FORMAT);
      const formattedDate = startDateObject.add(i, 'day').format(DateFormat.DD_MMM);

      formattedDates.push(formattedDate);
      dateStrings.push(currentDateObject);
    }
    return { formattedDates, dateStrings };
  };

  const { formattedDates, dateStrings } = createDateArray();

  return [
    {
      headerName: '',
      field: 'agentName',
      width: 150,
      className: 'px-[12px] py-[20px] flex items-center',
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <TableCellRenderer
            value={params?.data?.agentName}
            showToolTip
            toolTipContent={params?.data?.agentName}
          />
        );
      }
    },
    {
      headerName: '',
      width: 110,
      cellRenderer: () => {
        return renderContent(urlParams?.radioOption || 'All');
      }
    },
    ...generateColumns(formattedDates, dateStrings, urlParams)
  ];
};
